import ProfileContainer from 'modules/profile';
import Header from 'modules/header/farm/home';
import {useCookies} from 'react-cookie';
import {useEffect} from 'react';
const AccountPage = () => {
  const [, , removeCookie] = useCookies(['cultivationGuid']);
  useEffect(() => {
    removeCookie('cultivationGuid', {
      path: '/',
      domain: 'mazraeapp.com',
    });
  }, []);

  return (
    <>
      <Header />
      <ProfileContainer />
    </>
  );
};

export default AccountPage;
